import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import CurrentAppraisal from "molecules/CurrentAppraisal";
import AppraisalHistory from "molecules/AppraisalHistory";
import TabsList from "molecules/TabsList";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import { getDepartmentList, getUserList, getUserRoleId } from "redux/selectors";
import AttendAppraisal from "organisms/AttendAppraisal";
import ViewAppraisalResponse from "organisms/ViewAppraisalResponse";
import { Spin } from "antd";

const MyAppraisal = ({ departmentList, userList, UserRoleId }) => {
  const [myAppraisal, setMyAppraisal] = useState([]);
  const [appraisal, setAppraisal] = useState([]);
  const [history, setHistory] = useState([]);
  const [viewResponseData, setViewResponseData] = useState([]);
  const [pageView, setPageView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);

  let roleId = Array.isArray(UserRoleId) ? UserRoleId[0] : UserRoleId;

  let filteredDepartments =
    userList[0].userdepartmentid[roleId.toString()] || [];

  let matchedAppraisals = [];

  for (let i = 0; i < myAppraisal.length; i++) {
    if (
      myAppraisal.length &&
      filteredDepartments[0]?.includes(myAppraisal[i].departmentId) &&
      !myAppraisal[i].usersCompleted?.includes(userList[0].userid)
    ) {
      matchedAppraisals.push(myAppraisal[i]);
    }
  }

  const backStyle = { color: "#26A4FF", cursor: "pointer" };
  const pointerStyle = { cursor: "pointer" };
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await CALL_API(`appraisalform/appraisalhistory`, "get");
      setMyAppraisal(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchALlData = async () => {
    try {
      const res = await CALL_API(`appraisalform`, "get");
      setAppraisal(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchHistoryData();
    fetchALlData();
  }, []);

  const fetchHistoryData = async () => {
    try {
      const res = await CALL_API(`appraisalform/completedappraisal`, "get");
      setHistory(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  let items = [
    {
      id: 1,
      label: "Current appraisal",
      component: (
        <CurrentAppraisal
          myappraisal={true}
          myappraisalData={matchedAppraisals}
          appraisal={appraisal}
          setPageView={setPageView}
          setSelectedItem={setSelectedItem}
        />
      ),
    },
    {
      id: 2,
      label: "Appraisal History",
      component: (
        <AppraisalHistory
          myappraisal={true}
          appraisal={appraisal}
          history={history}
          myAppraisal={myAppraisal}
          setPageView={setPageView}
          setViewResponseData={setViewResponseData}
        />
      ),
    },
  ];
  return (
    <div>
      <section className="tabs_and_tableui">
        {pageView === "Attend" ? (
          <Row className="page-title">
            <Col sm={12} md={12}>
              <h4 className="common_title">
                <span
                  onClick={() => {
                    setPageView(false);
                  }}
                  className="back-btn"
                  style={backStyle}
                >
                  Back /
                </span>{" "}
                {selectedItem.title}
              </h4>
            </Col>
          </Row>
        ) : (
          <Row className="page-title">
            <Col sm={12} md={12}>
              <h4 className="common_title">
                <span style={pointerStyle} onClick={() => setPageView(false)}>
                  My Appraisal{" "}
                </span>{" "}
              </h4>
            </Col>
          </Row>
        )}

        {pageView === "Attend" ? (
          <AttendAppraisal
            selectedItem={selectedItem}
            pageView={pageView}
            setPageView={setPageView}
            myappraisalData={matchedAppraisals}
            attend={true}
            userList={userList[0]}
          />
        ) : pageView === "historyResponse" ? (
          <ViewAppraisalResponse
            pageView={pageView}
            setPageView={setPageView}
            response={viewResponseData}
            appraisal={appraisal}
          />
        ) : (
          <Spin spinning={loading}>
            <TabsList items={items} />
          </Spin>
        )}
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  departmentList: getDepartmentList(state),
  userList: getUserList(state),
  UserRoleId: getUserRoleId(state),
});

export default connect(mapStateToProps)(MyAppraisal);
